import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { DatePicker, DateRangePicker, DateTimePicker, Input } from "uxp/components";
import { hasValue } from "../../../../util";
import { CustomColorPicker, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";

interface IDateRangeFieldProperty extends IBaseInputFieldProperty {
	title?: string
	minDate?: string | Date
	maxDate?: string | Date
	fieldLabel:IFieldTitleProps,
}

export const Field: React.FunctionComponent<IUIFieldProps<IDateRangeFieldProperty>> = (props) => {
	let { value, onChange, title, minDate, maxDate } = props?.fieldProps || {};

	let styles: React.CSSProperties = {}
	if (!value) value = { start: new Date(), end: new Date() }

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />
			<DateRangePicker
				title={title || 'DateRange'}
				startDate={value?.start}
				endDate={value?.end}
				onChange={(s, e) => onChange({ start: s, end: e })}
				options={{
					minDate: minDate,
					maxDate: maxDate
				}}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IDateRangeFieldProperty>> = (props) => {

	let value = props.uiProps.value
	if(!value) value = {start: new Date(), end: new Date()}
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Date Range Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<DateRangePicker
					title="DateRange"
					startDate={value?.start}
					endDate={value?.end}
					onChange={(s, e) => props.onChange(Object.assign({}, props.uiProps, { value: { start: s, end: e } }))}
					showFullMonthName={false}
					hideLabels
					hideInput
				// compact
				/>
			</Property>
			<Property>
				<PropertyTitle>Min Date</PropertyTitle>
				<DatePicker
					title="Min Date"
					date={props.uiProps.minDate || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { minDate: s }))}
					showFullMonthName={false}
					hideLabels
					hideInput
				/>
			</Property>
			<Property>
				<PropertyTitle>Max Date</PropertyTitle>
				<DatePicker
					title="Max Date"
					date={props.uiProps.maxDate || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { maxDate: s }))}
					showFullMonthName={false}
					hideLabels
				/>
			</Property>
		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>;
}

registerUIField({
	id: 'daterange',
	category: 'date-time',
	description: 'Date Range Input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		fieldLabel:{
			label:'Pick a date range',
		},
	},
	type: 'daterange'

});
